import { map } from 'rxjs/operators';
import { ReportRecord } from '../../../../../models/report.model';
import { LovValues } from '../../../../../models/template.model';
import { displayFnWrapper, mapAndFormatDynamicValue } from '../../../utils/dynamic-data-retrievers';
import { currencyLov, PropertyType, valueWithUomPrefix } from '../../us/us.common';

export const displayFnMap = {
  354: {
    // 354 - status
    // clear
    displayFn: (record: ReportRecord, _, status) => {
      return status.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, status, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '';
        })
      );
    },
  },
  355: {
    // 355 - year built
    // clear
    displayFn: (record: ReportRecord, options, yearBuilt) => {
      const value = displayFnWrapper(record, options, yearBuilt);
      return Array.isArray(value) ? value.join(', ') : value;
    },
  },
  356: {
    // 356 - Class
    // clear
    displayFn: (record: ReportRecord, _, classArg) => {
      return classArg.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, classArg, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '-';
        })
      );
    },
  },
  427: {
    // 427 - date available
    // clear
    displayFn: displayFnWrapper,
  },
  353: {
    // 353 - Location/Transit (description)
    displayFn: (record: ReportRecord, _, locationDescriptionArg) => {
      const charLimit = 190;
      const descriptionValue: string = (mapAndFormatDynamicValue(record, locationDescriptionArg) as string) || '-';
      return descriptionValue.substring(0, charLimit);
    },
  },
  357: {
    // 357 - Average Direct Asking Rate Yearly
    // clear
    displayFn: (record: ReportRecord, options, askingRateYearly) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const value = valueWithUomPrefix(record, PropertyType.Office, askingRateYearly, currencyLOV);
          return Array.isArray(value) ? value.join(', ') : value;
        })
      );
    },
  },
  359: {
    // 359 - Service Charge
    // clear
    displayFn: (record: ReportRecord, options, serviceCharge) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const value = valueWithUomPrefix(record, PropertyType.Office, serviceCharge, currencyLOV);
          return Array.isArray(value) ? value.join(', ') : value;
        })
      );
    },
  },
  352: {
    // 352 - description
    // TODO: BE needs to support colloquial and not colloquial (currently only sending colloquial)
    displayFn: displayFnWrapper,
  },
  426: {
    // 426 - location transport
    // clear
    displayFn: displayFnWrapper,
  },
  367: {
    // 367 - Floor Label
    // clear
    displayFn: displayFnWrapper,
  },
  368: {
    // 368 - Usage Label
    // clear
    displayFn: displayFnWrapper,
  },
  369: {
    // 369 - Sqm label
    // clear
    displayFn: displayFnWrapper,
  },
  370: {
    // 370 - Available Label
    // clear
    displayFn: displayFnWrapper,
  },
  361: {
    // 361 - Parking Space
    displayFn: displayFnWrapper,
  },
  375: {
    // 375 - Class
    // clear
    displayFn: (record: ReportRecord, _, classArg) => {
      return classArg.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, classArg, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '-';
        })
      );
    },
  },
  437: {
    // 437 - date available
    // clear
    displayFn: displayFnWrapper,
  },
  436: {
    // 436 - location transport
    // clear
    displayFn: displayFnWrapper,
  },
  530: {
    // 530 - selected properties  label
    // clear
    displayFn: displayFnWrapper,
  },
};
